export function attachNativeValidation(form: HTMLFormElement): void {
    form.setAttribute("novalidate", "");

    const matchValidators = Array.from(form.querySelectorAll<HTMLInputElement>("input[data-match]"))
        .map(x => attachMatchValidation(form, x));

    form.addEventListener("submit", event => {
        matchValidators.forEach(x => x(true));

        if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
        }

        form.classList.add("was-validated");
    });
}

/**
 * Field that must equal another field of the form (e.g. a password confirmation):
 * data-match="<name of the other field>" and data-match-message="<error message>".
 * The server checks the same rule ([Compare]); this only gives feedback without a roundtrip.
 * Returns the validate function; showMessage forces the message to show (on submit).
 */
function attachMatchValidation(form: HTMLFormElement, input: HTMLInputElement): (showMessage?: boolean) => void {
    const other = form.querySelector<HTMLInputElement>(`input[name="${input.dataset.match}"]`);
    const messageElement = form.querySelector<HTMLElement>(`[data-valmsg-for="${input.name}"]`);
    const message = input.dataset.matchMessage ?? "";

    // Only show the message once the user left the field (or submitted), not while still typing
    let touched = false;

    const validate = (showMessage?: boolean): void => {
        if (!other) {
            return;
        }

        if (showMessage) {
            touched = true;
        }

        const mismatch = input.value !== "" && input.value !== other.value;
        input.setCustomValidity(mismatch ? message : "");

        if (messageElement && touched) {
            messageElement.textContent = mismatch ? message : "";
            messageElement.classList.toggle("field-validation-error", mismatch);
            messageElement.classList.toggle("field-validation-valid", !mismatch);
        }
    };

    input.addEventListener("input", () => validate());
    input.addEventListener("change", () => validate(true));
    other?.addEventListener("input", () => validate());

    return validate;
}
